import { styled } from 'styles';

export const Main = styled('main', {
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
});
